import type React from 'react';
import type { ReactNode } from 'react';
import classNames from 'classnames';
import ImgTrash from './img-trash.png';
import ImgReset from './img-reset.png';
import Icon from '../Icon';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  children?: ReactNode;
  placeholder?: ReactNode;
  warning?: boolean;
  useResetIcon?: boolean;
  onDeleteClick?: () => void;
}

function ImageContainer({
  className,
  style,
  placeholder,
  warning,
  children,
  useResetIcon = false,
  onDeleteClick,
}: Props) {
  const cx = classNames(
    'relative w-full bg-black text-black-gray text-sm border border-dark rounded',
    { 'ring-2 ring-red': warning },
    className
  );
  const showDel = !!onDeleteClick && !!children;
  return (
    <div className={cx} style={style}>
      <div className="absolute inset-3 flex items-center justify-center">
        {children || placeholder}
        {showDel && (
          <Icon
            src={useResetIcon ? ImgReset : ImgTrash}
            className="absolute right-2 top-2 cursor-pointer rounded-xs hover:bg-blue"
            onClick={onDeleteClick}
          />
        )}
      </div>
    </div>
  );
}

export default ImageContainer;
